import "../../CustomStyles/customStyle.css";
import Minagaramlogo from "../../assets/Agarathi_logo.png";
import PlayStorelogo from "../../assets/SharethisApp/PlayStore.svg";
import AppStorelogo from "../../assets/SharethisApp/AppStore.svg";
// import STA_MobileScreen from "../../assets/new_landing_page.png";
import ArrowUpRight from "../../assets/landing page/ArrowUpRight.png";
import { Button, Menu, message } from "antd";
import BackgroundImage from "../../assets/Background_image1.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import landing_image_mobile from "../../assets/mobile_back_ground_02.png";
import styles from "./landing_module.module.css";
import phone from "../../assets/mobile_back_ground_02.png";
import Footers_index from "../../Components/Footer/index_footer";
import { useNavigate } from "react-router-dom";
import mainscreenmobile from "../../assets/mainscreenmobile.png";
// import alldevices_sec_1 from "../../assets/alldevices_sec_1.png";
import sec1_round from "../../assets/sec1_round.png";
import sec1_devices from "../../assets/sec1_devices.png";
import round_devices from "../../assets/round_devices.png";
import alldevices_image from "../../assets/alldevices_image.png";
import vanakkam from "../../assets/vanakkam.png";
import sec2_Container from "../../assets/sec2_Container.png";
import sec3_icon_1 from "../../assets/sec3_icon_1.png";
import sec3_icon_2 from "../../assets/sec3_icon_2.png";
import sec3_icon_3 from "../../assets/sec3_icon_3.png";
import sec3_icon_4 from "../../assets/sec3_icon_4.png";
import sec3_icon_5 from "../../assets/sec3_icon_5.png";
import sec3_icon_6 from "../../assets/sec3_icon_6.png";
import download_android from "../../assets/download_android.png";
import download_ios from "../../assets/download_ios.png";
import intro_1 from "../../assets/intro_1.png";
import search_1 from "../../assets/search_1.png";
import level_1 from "../../assets/level_1.png";
import feedback_1 from "../../assets/feedback_1.png";
import wordofday_1 from "../../assets/wordofday_1.png";
import feedback_card from "../../assets/feedback_card.png";
import Quote_img from "../../assets/Quote_img.png";
import android_icon from "../../assets/android_icon.png";
import iphone_icon from "../../assets/iphone_icon.png";
import Appstore_scan from "../../assets/Appstore_scan.png";
import playstore_scan from "../../assets/playstore_scan.png";

// import indexsec_1 from "../../assets/indexsec_1.png";
// import indexsec1 from "../../assets/indexsec1.png";
import mainscreenipad from "../../assets/mainscreenipad.png";
import childimg from "../../assets/childimg.png";
// import boy_image from "../../assets/boy_image.png";
// import boyimage from "../../assets/boyimage.png";
import dot_image from "../../assets/dot_image.png";
import tick from "../../assets/tick.png";
import iphone_scan from "../../assets/iphone_scan.png";
import android_scan from "../../assets/android_scan.png";
import recent_viewed from "../../assets/recent_viewed.png";
import wordofday from "../../assets/wordofday.png";
import smart_search from "../../assets/smart_search.png";
import selectlevel from "../../assets/selectlevel.png";
import Intro from "../../assets/Intro.png";
import feedbackimg from "../../assets/feedback_img.png";
import quote from "../../assets/quote.png";
import arrow_line from "../../assets/arrow_line.png";
import feedstar from "../../assets/feedstar.png";
import feedbackbox from "../../assets/feedback-box.png";
import bckgrd_box from "../../assets/bckgrd_box.png";
import ArrowUp from "../../assets/ArrowUp.png";
import recentview_tab from "../../assets/recentview_tab.png";
import wordofday_tab from "../../assets/wordofday_tab.png";
import smartsearch_tab from "../../assets/smartsearch_tab.png";
import selectlevel_tab from "../../assets/selectlevel_tab.png";
import Intro_tab from "../../assets/Intro_tab.png";
import feedbackimg_tab from "../../assets/feedbackimg_tab.png";
import download_button from "../../assets/download_button.png";
import profile_button from "../../assets/profile_button.png";
import recentview_phone from "../../assets/recentview_phone.png";
import wordofday_phone from "../../assets/wordofday_phone.png";
import smartsearch_phone from "../../assets/smartsearch_phone.png";
import selectlevel_phone from "../../assets/selectlevel_phone.png";
import Intro_phone from "../../assets/Intro_phone.png";
import feedbackimg_phone from "../../assets/feedbackimg_phone.png";
import {
  STR_Copy_Failure_STA,
  STR_Copy_STA,
  STR_Copy_Success_STA,
  STR_Tam_Copy_Failure_STA,
  STR_Tam_Copy_STA,
  STR_Tam_Copy_Success_STA,
} from "../../Config.js/Strings";
import { ArrowRightOutlined, LinkOutlined } from "@ant-design/icons";
import { WhatsappShareButton, WhatsappIcon } from "react-share";
import { connect } from "react-redux";
import React, { useState, useEffect } from "react";
// import { Button } from "antd";
import LoginModal from "../../Pages/Authentication/Login";
import ForgetPasswordModal from "../../Pages/Authentication/ForgetPasswordView";
import SignUpModal from "../../Pages/Authentication/SignUp";
import user_icon from "../../assets/landing page/user_icon.png";
// import icon10 from "../../assets/Frame 9051.png";
import icon11 from "../../assets/inverted-commas1.png";
import { Link } from "react-router-dom";
import Word_of_the_image from "../../assets/landing page/word_of_the_day.png";
import image from "../../assets/landing page/image.png";
import audio from "../../assets/landing page/audio.png";
import select_level from "../../assets/landing page/select_level.png";
import recently from "../../assets/landing page/recently.png";
import saved from "../../assets/landing page/saved.png";
import idioms from "../../assets/landing page/idioms.png";
import topQuoteImage from "../../assets/right_x5F_quote.png";
import bottomQuoteImage from "../../assets/botton_left.png";
import { style } from "deprecated-react-native-prop-types/DeprecatedViewPropTypes";
import Footer from "../../Components/Footer/Footer";

import { useRef } from "react";

const SharethisApp = ({ isTamil }) => {
  const [isModalOpen, setIsModalOpen] = useState(false); // Login modal
  const [isForgotOpen, setIsForgotOpen] = useState(false); // Forgot password modal
  const [openSignUp, setOpenSignUp] = useState(false); // Signup modal
  // ---------- OPEN / CLOSE HANDLERS ----------
  const handleOpenLogin = () => setIsModalOpen(true);
  const handleCloseLogin = () => setIsModalOpen(false);

  const handleOpenForgot = () => setIsForgotOpen(true);
  const handleCloseForgot = () => setIsForgotOpen(false);

  const handleOpenSignUp = () => setOpenSignUp(true);
  const handleCloseSignUp = () => setOpenSignUp(false);
  const testimonials = [
    {
      text: "This app makes learning Tamil simple and enjoyable. The examples are so clear, and the Word of the Day keeps me motivated.",
      user: "Kannan",
      stars: 3,
    },
    {
      text: "I use Minagaram for school assignments. The meanings are accurate, and the grammar details help me understand every word better.",
      user: "Raja",
      stars: 4,
    },
    {
      text: " I can find meanings instantly. The smart search feature is super fast and precise. Great app for all levels!",
      user: "olivia",
      stars: 5,
    },
    {
      text: "The interface is neat and easy to use. Recently Viewed helps me revise words quickly. Highly recommended!",
      user: "Zineerah",
      stars: 4,
    },
    {
      text: "From vocabulary building to usage examples, this app has everything. One of the best Tamil dictionary apps out there.",
      user: "Lavanya",
      stars: 5,
    },
    {
      text: "I’ve been using Minagaram for months now. The content is rich, updated, and reliable. Great work by the team!",
      user: "Aravind",
      stars: 4,
    },
  ];
  const cardData = [
    {
      title: "Word of the day",
      description:
        "Learn one Tamil word each day with its meaning, usage, and related words. This supports consistent vocabulary building and reinforces language learning through daily practice.",
      image: Word_of_the_image,
    },
    {
      title: "Visual Learning with Images",
      description:
        "Selected words are supported with images to help learners visually associate meaning, making vocabulary easier to understand and remember.",
      image: image,
    },
    {
      title: "Audio Pronunciation Support",
      description:
        "Listen to correct pronunciation by tapping the audio icon next to a word. This helps improve listening accuracy and spoken Tamil skills.",
      image: audio,
    },
    {
      title: "Select Learning Levels",
      description:
        "Choose from Elementary, Intermediate, or Advanced levels to match your learning stage and progressively strengthen your understanding of Tamil usage.",
      image: select_level,
    },
    {
      title: "Recently Viewed Words",
      description:
        "Easily revisit words you explored earlier. This feature supports revision and reinforces learning through repetition.",
      image: recently,
    },
    {
      title: "Saved Words",
      description:
        "Bookmark important words and review them anytime to strengthen vocabulary and support long-term retention.",
      image: saved,
    },
    {
      title: "Idioms",
      description:
        "Idioms are expressions whose meanings differ from the literal interpretation of the words. Learn common Tamil idioms with clear explanations, examples, and contextual usage.",
      image: idioms,
    },
    {
      title: "Metaphors",
      description:
        "Explore how metaphors express ideas by relating one concept to another. This helps deepen understanding of meaning, cultural nuance, and expressive language use.",
      image: idioms,
    },
    {
      title: "Phrasemes",
      description:
        "Learn commonly used word combinations and set phrases in Tamil. Understanding these phrases improves fluency, accuracy, and natural language usage.",
      image: idioms,
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2800,
    arrows: false,
    pauseOnHover: false,
    centerMode: true,
    centerPadding: "0px 0px 0px 0px",
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerMode: true,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
    ],
  };

  const sliderRef = useRef(null);
  const isResetting = useRef(false);
  const totalSlides = 5;

  let agarathi_token = localStorage.getItem("agarathi_token");

  const shareUrl = "http://13.126.65.58/Min-Landing";

  const handleCopy = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(shareUrl);
        message.success(
          isTamil ? STR_Tam_Copy_Success_STA : STR_Copy_Success_STA,
        );
      } else {
        // Fallback for non-secure contexts or browsers without clipboard API
        const textArea = document.createElement("textarea");
        textArea.value = shareUrl;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand("copy");
          message.success(
            isTamil ? STR_Tam_Copy_Success_STA : STR_Copy_Success_STA,
          );
        } catch (err) {
          message.error(
            isTamil ? STR_Tam_Copy_Failure_STA : STR_Copy_Failure_STA,
          );
        } finally {
          document.body.removeChild(textArea);
        }
      }
    } catch (error) {
      message.error(isTamil ? STR_Tam_Copy_Failure_STA : STR_Copy_Failure_STA);
    }
  };

  useEffect(() => {
    const openForgot = () => setIsForgotOpen(true);
    const openSignUp = () => setOpenSignUp(true);
    const openLogin = () => setIsModalOpen(true);

    window.addEventListener("openForgotPopup", openForgot);
    window.addEventListener("openSignupPopup", openSignUp);
    window.addEventListener("openLoginPopup", openLogin);

    return () => {
      window.removeEventListener("openForgotPopup", openForgot);
      window.removeEventListener("openSignupPopup", openSignUp);
      window.removeEventListener("openLoginPopup", openLogin);
    };
  }, []);

  const menu = (
    <Menu>
      <Menu.Item key="1">
        <WhatsappShareButton url={shareUrl}>
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
      </Menu.Item>
      {/* <Menu.Item key="2">
        <FacebookShareButton url={shareUrl}>
          <FacebookIcon size={32} round />
        </FacebookShareButton>
      </Menu.Item>
      <Menu.Item key="3">
        <TwitterShareButton url={shareUrl}>
          <TwitterIcon size={32} round />
        </TwitterShareButton>
      </Menu.Item> */}
      <Menu.Item key="2" onClick={handleCopy}>
        <Button icon={<LinkOutlined />} type="link">
          {isTamil ? STR_Tam_Copy_STA : STR_Copy_STA}
        </Button>
      </Menu.Item>
    </Menu>
  );

  const scrollToSection = (id) => {
    const el = document.getElementById(id);

    if (!el) {
      console.log("Section not found:", id);
      return;
    }

    el.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

    // adjust for fixed header
    setTimeout(() => {
      window.scrollBy(0, -90);
    }, 300);
  };

  return (
    <div
      className={`${"pp"}`}
      style={{
        background: `linear-gradient(90deg, rgba(230, 250, 250, 0.96) 0%, rgba(230, 250, 250, 0.92) 57%, rgba(230, 250, 250, 1) 55%, rgba(230, 250, 250, 0.76) 100%, rgba(230, 250, 250, 0.45) 100%)`,
      }}
    >
      <section className="intex_page" id="intex_pagesection">
        {/* Logo and Title */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={Minagaramlogo}
            alt="Min Agaram Logo"
            style={{ width: "53px", marginRight: "2px" }}
          />
          <h1
            style={{ margin: 0, fontWeight: "600",fontSize:"24px" }}
            className={styles.title_minagaram}
          >
            Min Agaram
          </h1>
        </div>

        <div className="nav-links">
          <span onClick={() => scrollToSection("features")}>Features</span>
          <span onClick={() => scrollToSection("whyus")}>Why Us</span>
          <span onClick={() => scrollToSection("reviews")}>Reviews</span>
        </div>

        {/* get the app Button */}
        <div className="header-right">
          <button
            className="get-app-btn"
            onClick={() => scrollToSection("downloadSection")}
          >
            Get the App
            <img src={ArrowUp} alt="arrow" className="arrow-icon" />
          </button>
          <button
            className="get-app-btn2"
            onClick={() => scrollToSection("downloadSection")}
          >
            <img src={download_button} alt="" className="download-icon" />
          </button>
          {/* Login Button */}
          <Button
            onClick={handleOpenLogin}
            type="primary"
            classNames="login_popup"
            style={{ borderRadius: "12px" }}
            icon={
              <img
                src={user_icon}
                alt="User"
                className="index_minagaram_button"
              />
            }
            shape="round"
            className="new_navication_bar"
          >
            Login
            <img src={ArrowUpRight} alt="Arrow" className="index_menu_button" />
          </Button>
          {
            <img
              src={profile_button}
              alt="User"
              className="index_profilebutton"
              onClick={handleOpenLogin}
            />
          }
          <LoginModal
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
          <ForgetPasswordModal
            open={isForgotOpen}
            onClose={() => setIsForgotOpen(false)}
          />
          <SignUpModal open={openSignUp} onClose={() => setOpenSignUp(false)} />
        </div>
      </section>

      {/* <section class="main-section" id="mainSection">
        <div className={styles.new_container}>
          <img
            src={mainscreenipad}
            alt="MobileScreen"
            className="landing_image_ipad"
          />
          <div className="container_STA">
            <p className={styles.nuance}>
              Learn Tamil Smarter with{" "}
              <span className={styles.highlight}>Min Agaram</span>
            </p>
            <p className={styles.linguistic}>
              A structured and reliable platform for learning the Tamil
              language.
            </p>
            <p className={styles.uniqueness}>
              Developed in Singapore, Minagaram offers over 50,000 carefully
              curated Tamil words, supported by real-life examples,
              pronunciation aids, and clear grammatical explanations. It is
              designed to help beginners, students, and language learners
              understand Tamil accurately and use it confidently in both
              academic and everyday contexts.
            </p>
            <p className={styles.underline}></p>
            <p className={styles.get_minAgaram}>
              Download Minagaram today and strengthen your Tamil language
              skills.{" "}
            </p>
            <div className="dotimg">
              <img src={dot_image} alt="" className="dot_image" />
            </div>
            <div className={styles.PlayStorelogo}>
            <div className="shareButton_STA">
              <a
                href="https://apps.apple.com/sg/app/min-agaram/id6483002626"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={AppStorelogo}
                  alt="App Store"
                  className="AppStorelogo"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.tamil_agarathi_updated"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={PlayStorelogo}
                  alt="Google Play"
                  className="PlayStorelogo"
                />
              </a>
            </div>
          </div>
          </div>
          <div className="mobile-image-wrapper">
            <img
              src={sec1_round}
              alt="MobileScreen"
              className="landing_image_mobile"
            />

            <img src={sec1_devices} alt="alldevices" className="alldevices" />
          </div>
        </div>
      </section> */}

      <section className="main-section">
        <div className="main-container">
          {/* LEFT CONTENT */}
          <div className="main-text">
            <span className="badge">MASTER TAMIL SMARTER</span>

            <h1 className="main-title">
              Unlocking the <span className="highlight">Tamil</span> within you.
            </h1>

            <p className="main-desc">
              A structured and reliable platform to learn Tamil. From beginners
              to advanced learners, mastery made simple.
            </p>

            <button className="main-btn" onClick={handleOpenLogin}>
              Start Learning <span className="learn_arrow">→</span>
            </button>
          </div>

          {/* RIGHT IMAGE */}
          <div className="main-image">
            <img src={round_devices} className="bg-shape" alt="shape" />
            <div className="white_card">
              <img src={alldevices_image} className="devices" alt="devices" />
            </div>

            <div className="vanakkam-card">
              <h4>வணக்கம்</h4>
              <p>"Min Agaram connects you to your Tamil heritage."</p>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="section2_aboutus">
        
        <div className="dotimg">
          <img src={dot_image} alt="decorative dots" className="dot_image" />
        </div>

        
        <div className="childimg_about">
          <img
            src={boyimage}
            alt="Tamil learning illustration"
            className="childimg"
          />
        </div>

        
        <div className="aboutus_content">
          <div className={styles.underline_2}></div>

          <h2 className="about_heading">
            Explore the <span className={styles.highlightss}>Tamilverse</span>
          </h2>

          
          <div className="childimg_about2">
             <img
              src={boyimage}
              alt="Tamil learning illustration"
              className="childimg_2"
            /> 
          </div>

          <div className="abt_subheading">
            <p>A structured and reliable way to learn the Tamil language.</p>

            <p>
              Minagaram provides a structured Tamil dictionary with carefully
              curated vocabulary, real-life example sentences, and clear
              grammatical explanations. The platform is designed to help
              learners understand word meanings in context, apply correct usage,
              and build vocabulary progressively—supporting both academic
              learning and practical communication.
            </p>
          </div>

          
          <div className="dot2_img">
            <img src={dot_image} alt="decorative dots" className="dot2_image" />
          </div>
        </div>
      </section> */}

      <section className="tamilverse_container">
        {/* LEFT SIDE */}
        <div className="orbit_container">
          <div className="dashed_ring"></div>

          <img src={sec2_Container} alt="Learning" className="center_boy_img" />
        </div>

        {/* RIGHT SIDE */}
        <div className="features_content">
          <h2>
            Explore the <span className="highlight">Tamilverse</span>
          </h2>

          {/* FEATURES LIST */}
          <div className="features_list">
            <div className="feature_item">
              <img src={tick} className="tick_img" alt="tick" />
              <p>
                Min Agaram provides a structured Tamil learning experience that
                helps learners explore the depth and richness of the language
                with carefully curated vocabulary and real-life examples.
              </p>
            </div>

            <div className="feature_item">
              <img src={tick} className="tick_img" alt="tick" />
              <p>
                The platform offers clear grammar guidance to help learners
                understand Tamil naturally and build strong language skills step
                by step.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="learn_section">
        <div className="learn_container">
          <div className="about_title02">How Minagaram Supports Learning</div>

          <ul className="about_list">
            <li>
              <img src={tick} alt="" className="tick_img" />
              <div className="list-content">
                <strong>50,000+ Curated Tamil Words</strong>
                <p>
                  Organized to support both everyday communication and advanced
                  language learning.
                </p>
              </div>
            </li>

            <li>
              <img src={tick} alt="" className="tick_img" />
              <div className="list-content">
                <strong>Context-Based Example Sentences</strong>
                <p>
                  Each word is explained with real-life usage to improve
                  comprehension and retention.
                </p>
              </div>
            </li>

            <li>
              <img src={tick} alt="" className="tick_img" />
              <div className="list-content">
                <strong>Audio Pronunciation Support</strong>
                <p>
                  Selected words include clear pronunciation audio to help
                  learners hear, practice, and improve spoken Tamil.
                </p>
              </div>
            </li>

            <li>
              <img src={tick} alt="" className="tick_img" />
              <div className="list-content">
                <strong>Visual Support Through Images</strong>
                <p>
                  Relevant images are provided for selected words to strengthen
                  understanding and memory, especially for beginners.
                </p>
              </div>
            </li>

            <li>
              <img src={tick} alt="" className="tick_img" />
              <div className="list-content">
                <strong>Grammar & Word-Type Explanations</strong>
                <p>
                  Clear information on parts of speech, usage rules, and
                  language structure.
                </p>
              </div>
            </li>

            <li>
              <img src={tick} alt="" className="tick_img" />
              <div className="list-content">
                <strong>Structured Vocabulary Development</strong>
                <p>
                  Designed to help learners build vocabulary progressively and
                  meaningfully.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </section> */}

      <section className="support-main">
        <div className="support-wrapper">
          <div className="support-header">
            <h2 className="main-heading">How Min Agaram Supports Learning</h2>
            <span className="accent-bar"></span>
          </div>

          <div className="benefit-grid">
            <div className="benefit-list">
              <div className="icon-orb">
                <img src={sec3_icon_1} alt="icon" className="icon_img" />
              </div>
              <div className="benefit-info">
                <h3 className="benefit-title">50,000+ Curated Tamil Words</h3>
                <p className="benefit-detail">
                  Designed to support everyday communication and advanced
                  learning.
                </p>
              </div>
            </div>

            <div className="benefit-list">
              <div className="icon-orb">
                <img src={sec3_icon_2} alt="icon" class="icon_img" />
              </div>
              <div className="benefit-info">
                <h3 className="benefit-title">Image-based Word Learning</h3>
                <p className="benefit-detail">
                  Relevant images help learners understand and remember words
                  more easily.
                </p>
              </div>
            </div>

            <div className="benefit-list">
              <div className="icon-orb">
                <img src={sec3_icon_3} alt="icon" className="icon_img" />
              </div>
              <div className="benefit-info">
                <h3 className="benefit-title">
                  Context-based Example Sentences
                </h3>
                <p className="benefit-detail">
                  Each word includes real-life sentence examples to improve
                  comprehension and practical usage.
                </p>
              </div>
            </div>

            <div className="benefit-list">
              <div className="icon-orb">
                <img src={sec3_icon_4} alt="icon" className="icon_img" />
              </div>
              <div className="benefit-info">
                <h3 className="benefit-title">
                  Grammar and Word-type Explanations
                </h3>
                <p className="benefit-detail">
                  Clear explanations of parts of speech, usage rules, and
                  language structure.
                </p>
              </div>
            </div>

            <div className="benefit-list">
              <div className="icon-orb">
                <img src={sec3_icon_5} alt="icon" className="icon_img" />
              </div>
              <div className="benefit-info">
                <h3 className="benefit-title">Audio Pronunciation Support</h3>
                <p className="benefit-detail">
                  Listen to accurate pronunciation to practice speaking and
                  improve listening skills.
                </p>
              </div>
            </div>

            <div className="benefit-list">
              <div className="icon-orb">
                <img src={sec3_icon_6} alt="icon" className="icon_img" />
              </div>
              <div className="benefit-info">
                <h3 className="benefit-title">
                  Structured Vocabulary Development
                </h3>
                <p className="benefit-detail">
                  Helps learners build vocabulary progressively and naturally.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section class="download-section" id="downloadSection">
        <div class="download-container">
          
          <div class="download-left">
            <h2 class="download-title">
              Download the <span class="highlighter">Min Agaram</span>
              <br />
              App Today!
            </h2>

            <p class="download-desc">
              Begin your Tamil learning journey with a structured and reliable
              platform designed to support vocabulary development, correct
              usage, and long-term understanding.
            </p>

            <div class="stats">
              <div class="stat-block">
                <h3>3000+</h3>
                <p>Active Learners</p>
              </div>

              <div class="divider"></div>

              <div class="stat-block">
                <h3>50000 +</h3>
                <p>Curated Tamil Words</p>
              </div>
            </div>
            <p class="download-desc">Designed for learners of all levels.</p>
            <p class="download-bottom">
              Start learning Tamil with clarity, structure, and confidence using
              Minagaram.
            </p>
            <p class="download-bot"></p>
          </div>

          <div class="download-right">
            <div className="download-card">
              <img src={iphone_scan} alt="iphone" className="card-bg" />

              <div className="overlay">
                <p className="title">For iOS</p>
                <a
                  href="https://apps.apple.com/sg/app/min-agaram/id6483002626"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="download-btn">Download App</button>
                </a>
              </div>
            </div>
            <div className="download-card">
              <img src={android_scan} alt="android_scan" className="card-bg" />
              <div className="overlay">
                <p className="title">For Android</p>
                <a
                  href="https://play.google.com/store/apps/details?id=com.tamil_agarathi_updated"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="download-btn">Download App</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section
        className="outer-section"
        id="downloadSection"
        style={{ margintop: "50px" }}
      >
        <div className="download-sec">
          <div className="download-content">
            {/* LEFT CONTENT */}
            <div className="download-text">
              <h2>
                Download the <span className="brand-highlight">Min Agaram</span>{" "}
                App Today!
              </h2>

              <p className="description">
                Begin your Tamil learning journey with a structured and reliable
                platform designed to support vocabulary development, correct
                usage, and long-term understanding.
              </p>

              <div className="stats-container">
                <div className="stat-item">
                  <h3>3000+</h3>
                  <p>Active Learners</p>
                </div>

                <div className="stat-divider"></div>

                <div className="stat-item">
                  <h3>50000+</h3>
                  <p>Curated Tamil Words</p>
                </div>
              </div>
            </div>

            {/* RIGHT CARDS */}
            <div className="cards-container">
              {/* iOS CARD */}
              <div className="download-card">
                <img src={iphone_icon} alt="Apple" className="platform-icon" />
                <p className="platform">For iOS</p>

                <a
                  href="https://apps.apple.com/sg/app/min-agaram/id6483002626"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="download-btn">Download App</button>
                </a>

                <img src={Appstore_scan} alt="iOS QR" className="qr-img" />
              </div>

              {/* ANDROID CARD */}
              <div className="download-card">
                <img
                  src={android_icon}
                  alt="Android"
                  className="platform-icon"
                />
                <p className="platform">For Android</p>

                <a
                  href="https://play.google.com/store/apps/details?id=com.tamil_agarathi_updated"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="download-btn">Download App</button>
                </a>

                <img src={playstore_scan} alt="Android QR" className="qr-img" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="feat_sec" id="features">
        <div className="feat_container">
          <h2 className="feat_title">
            Key Features of <span className="highlightkey"> Min Agaram</span>
          </h2>
          <div className="cards_container">
            <Slider
              // ref={sliderRef}
              {...settings}
              className="cards_slider"
              speed={600}
              slidesToShow={3}
              slidesToScroll={1}
              autoplay
              autoplaySpeed={3000}
              arrows={false}
              pauseOnHover={false}
              responsive={[
                { breakpoint: 1024, settings: { slidesToShow: 2 } },
                { breakpoint: 800, settings: { slidesToShow: 3 } },
                { breakpoint: 480, settings: { slidesToShow: 1 } },
              ]}
            >
              <div className="card_list">
                <div className="card_text">
                  <h3>Topic Introduction</h3>
                  <p>
                    Get a clear overview of each topic, including concepts and
                    learning coverage.
                  </p>
                </div>
                <img src={intro_1} />
              </div>

              <div className="card_list">
                <div className="card_text">
                  <h3>Word of the Day</h3>
                  <p>
                    Discover and learn a fresh Tamil word every day to expand
                    your vocabulary and cultural understanding.
                  </p>
                </div>
                <img src={wordofday_1} />
              </div>

              <div className="card_list">
                <div className="card_text">
                  <h3>Smart Search</h3>
                  <p>
                    Quickly find any Tamil word with precise meanings and
                    examples, all in just a few taps.
                  </p>
                </div>
                <img src={search_1} />
              </div>

              <div className="card_list">
                <div className="card_text">
                  <h3>Select your Level</h3>
                  <p>
                    Choose a learning level that matches your proficiency and
                    progress with structured content.
                  </p>
                </div>
                <img src={level_1} />
              </div>

              <div className="card_list">
                <div className="card_text">
                  <h3>User Feedback</h3>
                  <p>
                    Rate and share feedback to help us continuously improve your
                    experience.
                  </p>
                </div>
                <img src={feedback_1} />
              </div>
            </Slider>
          </div>
        </div>
      </section>

      {/* <section className="features-sec">
        <div className="features-container">
          <h2 className="feature-title">
            <span className="highlightkey">Key Features</span> of <br /> Min
            Agaram
          </h2>

          <Slider
            ref={sliderRef}
            className="cards_slider"
            dots={false}
            infinite={false}
            speed={600}
            slidesToShow={3}
            slidesToScroll={1}
            autoplay
            autoplaySpeed={3500}
            arrows={false}
            pauseOnHover={false}
            responsive={[
              { breakpoint: 1024, settings: { slidesToShow: 2 } },
              { breakpoint: 800, settings: { slidesToShow: 1 } },
            ]}
            afterChange={(current) => {
              // ignore afterChange triggered by jump
              if (isResetting.current) {
                isResetting.current = false;
                return;
              }

              const slidesToShow =
                window.innerWidth <= 800
                  ? 1
                  : window.innerWidth <= 1024
                    ? 2
                    : 3;

              const lastIndex = totalSlides - slidesToShow;

              
              if (current === lastIndex) {
                isResetting.current = true;

                setTimeout(() => {
                  sliderRef.current?.slickGoTo(0, false);
                }, 5000); 
              }
            }}
          >  */}
      {/* CARD TEMPLATE (reuse same structure for all 6 cards) */}
      {/* ================= 1. RECENT VIEWED ================= */}
      {/* <div className="feature-card">
              Desktop
              <div className="card-desktop">
                <img src={recent_viewed} alt="Recently Viewed" />
                <div className="card-text top">
                  <h3>Recently Viewed</h3>
                  <p>
                    Easily resume your learning journey from where you left
                    off—never lose track of the words you've explored.
                  </p>
                </div>
              </div>

              Tablet
              <div className="card-tablet">
                <img src={recentview_tab} alt="Recently Viewed" />
                <div className="card-text right">
                  <h3>Recently Viewed</h3>
                  <p>
                    Easily resume your learning journey from where you left
                    off—never lose track of the words you've explored.
                  </p>
                </div>
              </div>

              Mobile
              <div className="card-mobile">
                <img src={recentview_phone} alt="Recently Viewed" />
                <div className="card-mobile-text">
                  <h3>Recently Viewed</h3>
                  <p>
                    Easily resume your learning journey from where you left
                    off—never lose track of the words you've explored.
                  </p>
                </div>
              </div>
            </div> */}

      {/* ================= WORD OF THE DAY ================= */}
      {/* <div className="feature-card">
              <div className="card-desktop">
                <img src={wordofday} />
                <div className="card-text bottom">
                  <h3>Word of the Day</h3>
                  <p>
                    Discover a new Tamil word every day and steadily expand your
                    vocabulary and cultural understanding.
                  </p>
                </div>
              </div>

              <div className="card-tablet">
                <img src={wordofday_tab} />
                <div className="card-text left">
                  <h3>Word of the Day</h3>
                  <p>
                    Discover a new Tamil word every day and steadily expand your
                    vocabulary and cultural understanding.
                  </p>
                </div>
              </div>

              <div className="card-mobile">
                <img src={wordofday_phone} className="card_phone_img02" />
                <div className="card-mobile-text">
                  <h3>Word of the Day</h3>
                  <p>
                    Discover a new Tamil word every day and steadily expand your
                    vocabulary and cultural understanding.
                  </p>
                </div>
              </div>
            </div>

            ================= SMART SEARCH =================
            <div className="feature-card">
              <div className="card-desktop">
                <img src={smart_search} />
                <div className="card-text top">
                  <h3>Smart Search</h3>
                  <p>
                    Quickly find any Tamil word with accurate meanings, clear
                    explanations, and real-life examples—all in just a few taps.
                  </p>
                </div>
              </div>

              <div className="card-tablet">
                <img src={smartsearch_tab} />
                <div className="card-text right">
                  <h3>Smart Search</h3>
                  <p>
                    Quickly find any Tamil word with accurate meanings, clear
                    explanations, and real-life examples—all in just a few taps.
                  </p>
                </div>
              </div>

              <div className="card-mobile">
                <img src={smartsearch_phone} />
                <div className="card-mobile-text">
                  <h3>Smart Search</h3>
                  <p>
                    Quickly find any Tamil word with accurate meanings, clear
                    explanations, and real-life examples—all in just a few taps.
                  </p>
                </div>
              </div>
            </div>

            ================= SELECT LEVEL =================
            <div className="feature-card">
              <div className="card-desktop">
                <img src={selectlevel} />
                <div className="card-text bottom">
                  <h3>Select Your Level</h3>
                  <p>
                    Choose a learning level that matches your proficiency and
                    progress with structured content.
                  </p>
                </div>
              </div>

              <div className="card-tablet">
                <img src={selectlevel_tab} />
                <div className="card-text left">
                  <h3>Select Your Level</h3>
                  <p>
                    Choose a learning level that matches your proficiency and
                    progress with structured content.
                  </p>
                </div>
              </div>

              <div className="card-mobile">
                <img src={selectlevel_phone} className="card_phone_img" />
                <div className="card-mobile-text">
                  <h3>Select Your Level</h3>
                  <p>
                    Choose a learning level that matches your proficiency and
                    progress with structured content.
                  </p>
                </div>
              </div>
            </div>

            ================= TOPIC INTRO =================
            <div className="feature-card">
              <div className="card-desktop">
                <img src={Intro} />
                <div className="card-text top">
                  <h3>Topic Introduction</h3>
                  <p>
                    Get a clear overview of each topic, including concepts and
                    learning coverage.
                  </p>
                </div>
              </div>

              <div className="card-tablet">
                <img src={Intro_tab} />
                <div className="card-text right">
                  <h3>Topic Introduction</h3>
                  <p>
                    Get a clear overview of each topic, including concepts and
                    learning coverage.
                  </p>
                </div>
              </div>

              <div className="card-mobile">
                <img src={Intro_phone} className="card_phone_img2" />
                <div className="card-mobile-text">
                  <h3>Topic Introduction</h3>
                  <p>
                    Get a clear overview of each topic, including concepts and
                    learning coverage.
                  </p>
                </div>
              </div>
            </div>

            ================= FEEDBACK =================
            <div className="feature-card">
              <div className="card-desktop">
                <img src={feedbackimg} />
                <div className="card-text bottom">
                  <h3>User Feedback</h3>
                  <p>
                    Rate and share feedback to help us continuously improve your
                    experience.
                  </p>
                </div>
              </div>

              <div className="card-tablet">
                <img src={feedbackimg_tab} />
                <div className="card-text left">
                  <h3>User Feedback</h3>
                  <p>
                    Rate and share feedback to help us continuously improve your
                    experience.
                  </p>
                </div>
              </div>

              <div className="card-mobile">
                <img src={feedbackimg_phone} className="card_phone_img" />
                <div className="card-mobile-text">
                  <h3>User Feedback</h3>
                  <p>
                    Rate and share feedback to help us continuously improve your
                    experience.
                  </p>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </section> */}

      {/* <section
        className={styles.hero}
        style={{ backgroundImage: `url(${BackgroundImage})` }}
      >
        <h2 className={styles.headline}>Explore the Tamilverse</h2>

        <img src={phone} alt="Min Agaram phone demo" className={styles.phone} />

        <Callout
          text="Notification"
          desc="Notifications in Min Agaram keep users
updated on new words, tips, and app
enhancements."
          side={styles.top}
        />
        <Callout
          text="Search Bar"
          desc="The Search Bar in Min Agaram
enables quick and accurate word
search with smart suggestions."
          side={styles.right}
        />
        <Callout
          text="Saved Words"
          desc="The Saved Words feature in Min
Agaram lets users bookmark and
revisit important words easily."
          side={styles.bottomRight}
        />
        <Callout
          text="Word of the Day"
          desc="The Word of the Day in Min Agaram
helps users learn a new Tamil word
daily and expand their vocabulary."
          side={styles.bottomLeft}
        />
        <Callout
          text="Navigation Bar"
          desc="Allows users to access essential
features quickly for an efficient and
user-friendly experience."
          side={styles.left}
        />
      </section> */}
      <div>
        <div className="share_page_01" id="whyus">
          {/* <div className="share_grid_02">
            <Card icon={Word_of_the_image} title="Word of the day" />
            <Card icon={icon2} title="Image" />
            <Card icon={icon3} title="Audio" />
            <Card icon={icon4} title="Select levels" />
            <Card icon={icon5} title="Recently Viewed" />
            <Card icon={icon6} title="Saved Words" />
            <Card icon={icon7} title="Idioms" />
            <Card icon={icon8} title="Metaphors" />
            <Card icon={icon9} title="Phrasemes" />
          </div> */}

          <div className="landing-container">
            <h2 className="landing-container-title">
              Why Learners Choose Minagaram
            </h2>
            <div className="landing-container-grid">
              {cardData.map((card, index) => (
                <div className="landing-container-card" key={index}>
                  <div className="landing-container-icon">
                    <img src={card.image} alt={card.title} />
                  </div>
                  <h3 className="landing-container-card-title">{card.title}</h3>
                  <p className="landing-container-card-desc">
                    {card.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* <div className="feedback_container">
        <div className="feed_head">
          <div className="head_01">A Dictionary That Grows With You</div>
          <p className="head_02">
            From daily-use words to advanced vocabulary — we cover it all.
          </p>
          <p className="head_02">Learn Tamil at your pace, the smart way.</p>
        </div>
        <div className="feedback_row">
         
          <div className="feedback_left">
            <img src={quote} alt="" className="quote-img" />
            <h1 className="content_left">What Our Learners Are Saying</h1>
            <img src={arrow_line} alt="" className="arrow_line" />
          </div>

         
          <div className="feedback_right">
            <Slider {...settings}>
              {testimonials.map((item, i) => (
                <div key={i} className="testimonial-slide">
                  <div className="testimonial-card">
                    <p className="testimonial-text">{item.text}</p>
                    <div className="testimonial-rating">
                      {[...Array(item.stars)].map((_, index) => (
                        <img
                          key={index}
                          src={feedstar}
                          alt="star"
                          className="star-icon"
                        />
                      ))}
                    </div>
                    <p className="testimonial-user">{item.user}</p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div> */}

      {/* <section className="feedback_container">
        <div className="feed_head">
          <h2 className="head_01">What Our Learners Are Saying</h2>
        </div>

        <div className="feedback_row">
          <div className="feedback_right">
            <Slider {...settings}>
              {testimonials.map((item, i) => (
                <div key={i} className="testimonial-slide">
                  <div
                    className="testimonial-card"
                    style={{ backgroundImage: `url(${feedbackbox})` }}
                  >
                    <p className="testimonial-text">{item.text}</p>

                    <div className="testimonial-rating">
                      {[1, 2, 3, 4, 5].map((starIndex) => {
                        const rating = item.stars; // e.g. 4.5

                        if (starIndex <= Math.floor(rating)) {
                          return (
                            <img
                              key={starIndex}
                              src={feedstar}
                              alt="star"
                              className="star-icon"
                            />
                          );
                        }

                        if (
                          starIndex === Math.ceil(rating) &&
                          rating % 1 !== 0
                        ) {
                          return (
                            <span key={starIndex} className="star-half">
                              <img
                                src={feedstar}
                                className="star-left"
                                alt="star"
                              />
                              <img
                                src={feedstar}
                                className="star-right"
                                alt="star"
                              />
                            </span>
                          );
                        }

                        return (
                          <img
                            key={starIndex}
                            src={feedstar}
                            alt="star"
                            className="star-icon star-empty"
                          />
                        );
                      })}
                    </div>

                    <p className="testimonial-user">{item.user}</p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section> */}

      <section className="feedback_contain" id="reviews">
        <div className="feedback_section">
          {/* TOP TEXT */}
          <div className="feedback_top">
            <p className="top_line1">Learn Tamil with confidence</p>
            <h3 className="top_line2">
              தமிழை எளிதாகவும் திறமையாகவும் கற்றுக்கொள்ளுங்கள்
            </h3>

            <div className="rating_summary">
              <span className="rating_star">★</span>
              <span className="rating_value">4.2/5</span>
              <span className="brand"></span>
              <span className="reviews">5,000+ reviews</span>
            </div>
          </div>

          <div className="feedback_wrapper">
            {/* LEFT SIDE (NEW DESIGN) */}
            <div className="feedback_left">
              <div className="quote_icon">
                <img src={Quote_img} alt="quote" />
              </div>

              <h2 className="feedback_title">What Our Learners Are Saying</h2>

              <div className="feedback_nav">
                <img src={arrow_line} alt="arrow" />
              </div>
            </div>

            {/* RIGHT SIDE (OLD SLIDER + NEW CARD UI) */}
            <div className="feedback_right">
              <Slider {...settings}>
                {testimonials.map((item, i) => (
                  <div key={i} className="testimonial-slide">
                    <div className="testimonial_card">
                      <p className="testimonial_text">{item.text}</p>

                      {/* ⭐ STAR SECTION */}
                      <div className="testimonial-rating">
                        {[1, 2, 3, 4, 5].map((starIndex) => {
                          const rating = item.stars;

                          if (starIndex <= Math.floor(rating)) {
                            return (
                              <img
                                key={starIndex}
                                src={feedstar}
                                alt="star"
                                className="star-icon full"
                              />
                            );
                          }

                          if (
                            starIndex === Math.floor(rating) + 1 &&
                            rating % 1 !== 0
                          ) {
                            return (
                              <div key={starIndex} className="star-wrapper">
                                <img
                                  src={feedstar}
                                  alt="star"
                                  className="star-icon empty"
                                />
                                <img
                                  src={feedstar}
                                  alt="star"
                                  className="star-icon half"
                                />
                              </div>
                            );
                          }

                          return (
                            <img
                              key={starIndex}
                              src={feedstar}
                              alt="star"
                              className="star-icon empty"
                            />
                          );
                        })}
                      </div>

                      <p className="testimonial_user">{item.user}</p>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>

      <div className="new_landing_footer">
        <Footers_index />
      </div>
    </div>
  );
};

function Callout({ text, desc, side }) {
  return (
    <div className={`${styles.callout} ${side}`}>
      <h4>{text}</h4>
      <p>{desc}</p>
      <span className={styles.line} />
    </div>
  );
}
// Map Redux state to component props
const mapStateToProps = (state) => ({
  isTamil: state.LanguageReducer.isTamil,
});

export default connect(mapStateToProps)(SharethisApp);
